export default __webpack_public_path__ + "assets/c8f9318ec544d04f471541c352659961.png";